@if (isLoading) {
  <div class="flex items-center justify-center h-full w-full">
    <div class="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
  </div>
}